import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SidebarLeftOpen.svg",
  "use": "SidebarLeftOpen.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SidebarLeftOpen.svg\"><path d=\"M52,52H12a4,4,0,0,1-4-4V16a4,4,0,0,1,4-4H52a4,4,0,0,1,4,4V48A4,4,0,0,1,52,52ZM22,17a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1V47a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1Zm23.586,14.1746-9.974-6.9888a1.0275,1.0275,0,0,0-1.6227.8191V38.9825a1.0274,1.0274,0,0,0,1.6227.8189l9.974-6.9887A.9954.9954,0,0,0,45.5858,31.1746Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol